import React, { useEffect } from "react";
import { TableHeadersType } from "../../../constant/tableHeadersConstants/tableHeadersType";
import {
  CollapseClose,
  CollapseOpen,
  LockGreyIcon,
} from "../../../assets/images";
import ItemDataTable from "./ItemDataTable";
import Select from "react-select";
import {
  fillingDates,
  finacialYearMonth,
  reclaimFinacialYearMonth,
} from "../../commons/Gst";
import {
  OutwardsDataType,
  UpdateOutwardDataPayload,
} from "../../../commonTypes/gstTypes";
import { Link } from "react-router-dom";
import { useMenuCheck } from "../../../customHooks/useMenuCheck";
import { formatDate } from "../../../utils/commonFunctions";
import {
  AGREE_DISAGREE_OPTIONS,
  CLASSIFICATION_OPTIONS,
  GST_EXEMPTION,
  REVERSE_CHARGE_INWARD_OPTIONS,
  REVERSE_CHARGE_OUTWARD_OPTIONS,
  WHETHER_ELIGIBLE_OPTIONS,
} from "../../../constant/tableHeadersConstants/gst";

type AppProps = {
  token?: string | null;
  client_code?: number;
  type: string;
  updateData: (data: UpdateOutwardDataPayload) => void;
  fetching?: boolean;
  isClickable: boolean;
  tableHeader: TableHeadersType[];
  tableData: OutwardsDataType[];
  itemHeader: TableHeadersType[];
  setData: Function;
  history: any;
  persistData?: any;
};

const tableSelect = {
  control: (baseStyles: any, state: any) => ({
    ...baseStyles,
    border: "1px solid #2080f6",
  }),
  dropdownIndicator: (base: any) => ({
    ...base,
    color: "#7c8db0", // Custom colour
  }),
};

const MainTableBody = ({
  token,
  client_code,
  fetching,
  tableData,
  type,
  setData,
  tableHeader,
  isClickable,
  itemHeader,
  history,
  updateData,
  persistData,
}: AppProps) => {
  let company_name: string = history?.location?.state?.company_name
    ? history?.location?.state?.company_name
    : null;
  let newData = JSON.parse(JSON.stringify(tableData));
  const renderMainTableRow = () => {
    const handleInputChange = (e: any, id: string, name: string) => {
      let data_to_update: any = {};
      if (
        name === "whether_eligible" &&
        type !== "outward" &&
        e.value !== "No - Other"
      ) {
        data_to_update["reclaim"] = "";
      }
      data_to_update[name] = e.value;

      let finalData =
        type === "outward"
          ? {
              token,
              client_code,
              gst_outward_id: id,
              data_to_update,
            }
          : {
              token,
              client_code,
              gst_inward_id: id,
              data_to_update,
            };
      updateData(finalData);
      persistData.current = structuredClone([...newData]);

      newData?.map((item: any) => {
        if (item._id === id) {
          item[name] = e.value;
          //   item["reclaim"] = "";
          if (name === "whether_eligible" && e.value !== "No - Other") {
            item["reclaim"] = "";
          }
        }
      });
      setData([...newData]);
    };

    const gstr1_options: TableHeadersType[] = fillingDates(2020, "Mar")?.map(
      (e: TableHeadersType) => {
        return {
          label: e.label,
          value: e.value,
        };
      }
    );

    const getReclaimMonthsOptions = (
      startYear: string,
      month: string,
      endYear: string
    ) => {
      const reclaimMonthData = reclaimFinacialYearMonth(
        startYear,
        month,
        +endYear
      )?.map((e: TableHeadersType) => {
        return {
          label: e.label,
          value: e.value,
        };
      });
      return reclaimMonthData;
    };

    const convertDocumentType = (type: string) => {
      switch (type) {
        case "tax_invoice":
          return "Tax Invoice";
        case "credit_note":
          return "Credit Note";
        case "debit_note":
          return "Debit Note";
        case "recepits":
          return "Purchase Order";
        case "rcm_invoice":
          return "Tax Invoice(RCM applicable)";
        default:
          return "";
      }
    };

    const convertGstr1Type = (type: string) => {
      switch (type) {
        case "6A_export_with_payment":
          return "6A-EXPWP";
        case "6A_export_without_payment":
          return "6A-EXPWOP";
        case "6B_sez_with_payment":
          return "6B-SEZWP";
        case "6B_sez_without_payment":
          return "6B-SEZWOP";
        case "7_tax_invoice":
          return "7-Tax Invoice";
        case "7_debit_note":
          return "7-Debit Note";
        case "7_credit_note":
          return "7-Credit";
        case "8_nill_rated":
          return "8-Nil Rated";
        case "8_exempt_supply":
          return "8-Exempt Supply";
        case "8_non_rated":
          return "8-Non Rated";
        case "9B_registered_regular":
          return "9B-Registered Regular";
        case "9B_reverse_charges":
          return "9B-Reverse Charges";
        case "9B_sez_with_payment":
          return "9B-SEZWP";
        case "9B_unregistered_b2cl":
          return "9B-Unregisterd B2CL";
        case "9B_unregiestered_export_with_payment":
          return "9B-Unregisterd EXPWP";
        case "9B_unregistered_export_without_payment":
          return "9B-Unregisterd EXPWOP";
        default:
          return type;
      }
    };

    const finalTableData =
      newData?.length &&
      newData?.map((dataItem: any, i: any) => {
        let finalRedirectLink =
          dataItem?.invoice_id &&
          (dataItem?.invoice_type === "revenues" ||
            dataItem?.invoice_type === "expenses")
            ? `/invoice-generation/edit/${dataItem?.invoice_id}/${client_code}?type=${dataItem?.invoice_type}&client_code=${client_code}&company_name=${company_name}`
            : `/invoice-generation/edit-others/${client_code}/${dataItem?.invoice_id}?type=others&client_code=${client_code}&company_name=${company_name}`;
        let str = "";
        dataItem.gstr1_type_arr?.map((item: any) => {
          str += convertGstr1Type(item) + " , ";
        });
        let gstr3BType = "";
        dataItem.gstr3b_type_arr?.map((item: any) => {
          gstr3BType += convertGstr1Type(item) + " , ";
        });
        return (
          <>
            <tr
              style={{
                backgroundColor:
                  dataItem?.is_gstr1_filed !== 1 ? "white" : "#eef0f4",
              }}
            >
              {tableHeader?.length &&
                tableHeader?.map((header: TableHeadersType) => {
                  if (type === "outward") {
                    if (
                      header.value === "customer_name_gst" &&
                      type === "outward"
                    ) {
                      return (
                        <td className="data_inside_table">
                          <div>{dataItem?.customer_name}</div>
                          <div className="below-header">
                            {dataItem?.customer_gstin}
                          </div>
                        </td>
                      );
                    } else if (
                      header.value === "invoice_id" &&
                      type === "outward"
                    ) {
                      return (
                        <td className="data_inside_table">
                          {dataItem.invoice_id}
                        </td>
                      );
                    } else if (
                      header.value === "gstr1_type" &&
                      type === "outward"
                    ) {
                      return (
                        <td className="data_inside_table">
                          {str?.slice(0, str.length - 2)}
                        </td>
                      );
                    } else if (
                      header.value === "gstr3b_type_arr" &&
                      type === "outward"
                    ) {
                      return (
                        <td
                          className="data_inside_table"
                          style={{
                            whiteSpace: gstr3BType ? "normal" : "nowrap",
                            wordBreak: "break-word",
                            minWidth: "300px",
                          }}
                        >
                          {gstr3BType
                            ? gstr3BType?.slice(0, gstr3BType.length - 2)
                            : "NA"}
                        </td>
                      );
                    } else if (
                      header.value === "table_no_of_gstr1" &&
                      type === "outward"
                    ) {
                      return (
                        <td className="data_inside_table">
                          {dataItem?.is_gstr1_filed !== 1 ? (
                            <Select
                              styles={tableSelect}
                              components={{
                                IndicatorSeparator: () => null,
                              }}
                              placeholder="Select Date"
                              disabled={fetching}
                              name="table_no_of_gstr1"
                              options={gstr1_options}
                              value={
                                dataItem.table_no_of_gstr1
                                  ? {
                                      label: dataItem.table_no_of_gstr1,
                                      value: dataItem.table_no_of_gstr1,
                                    }
                                  : null
                              }
                              isSearchable
                              onChange={(e) =>
                                handleInputChange(
                                  e,
                                  dataItem._id,
                                  "table_no_of_gstr1"
                                )
                              }
                            />
                          ) : (
                            dataItem.table_no_of_gstr1
                          )}
                        </td>
                      );
                    } else if (
                      header.value === "gst_exemption" &&
                      type === "outward"
                    ) {
                      return (
                        <td className="data_inside_table">
                          {dataItem?.is_gstr1_filed !== 1 ? (
                            <Select
                              styles={tableSelect}
                              components={{
                                IndicatorSeparator: () => null,
                              }}
                              placeholder="Select"
                              name="gst_exemption"
                              value={
                                dataItem.gst_exemption
                                  ? dataItem?.gst_exemption === "nil_rated"
                                    ? { label: "Nil Rated", value: "nil_rated" }
                                    : dataItem?.gst_exemption ===
                                      "exempted_supply"
                                    ? {
                                        label: "Exempted Supply",
                                        value: "exempted_supply",
                                      }
                                    : dataItem?.gst_exemption === "non_gst"
                                    ? { label: "Non GST", value: "non_gst" }
                                    : null
                                  : null
                              }
                              disabled={fetching}
                              options={GST_EXEMPTION}
                              onChange={(e) =>
                                handleInputChange(
                                  e,
                                  dataItem._id,
                                  "gst_exemption"
                                )
                              }
                            />
                          ) : dataItem?.gst_exemption === "nil_rated" ? (
                            "Nil Rated"
                          ) : dataItem?.gst_exemption === "exempted_supply" ? (
                            "Exempted Supply"
                          ) : dataItem?.gst_exemption === "non_gst" ? (
                            "Non GST"
                          ) : (
                            "None"
                          )}
                        </td>
                      );
                    } else if (
                      header.value === "supply_to_composition_on_dealer" &&
                      type === "outward"
                    ) {
                      return (
                        <td className="data_inside_table">
                          {
                            // <div style={{width:"161px"}}>
                            <Select
                              styles={tableSelect}
                              components={{
                                IndicatorSeparator: () => null,
                              }}
                              placeholder="Select"
                              disabled={fetching}
                              name="supply_to_composition_on_dealer"
                              value={
                                dataItem.supply_to_composition_dealer
                                  ? dataItem.supply_to_composition_dealer ===
                                    "Yes"
                                    ? AGREE_DISAGREE_OPTIONS[0]
                                    : AGREE_DISAGREE_OPTIONS[1]
                                  : null
                              }
                              options={AGREE_DISAGREE_OPTIONS}
                              onChange={(e) =>
                                handleInputChange(
                                  e,
                                  dataItem._id,
                                  "supply_to_composition_dealer"
                                )
                              }
                            />
                            // </div>
                          }
                        </td>
                      );
                    } else if (
                      header.value === "deemed_export" &&
                      type === "outward"
                    ) {
                      return (
                        <td className="data_inside_table">
                          {dataItem?.demmed_export}
                        </td>
                      );
                    } else if (
                      header.value === "exports" &&
                      type === "outward"
                    ) {
                      return (
                        <td className="data_inside_table">
                          {dataItem?.exports}
                        </td>
                      );
                    } else if (
                      header.value === "exports_tax_payment" &&
                      type === "outward"
                    ) {
                      return (
                        <td className="data_inside_table">
                          {dataItem?.exports_tax_payment}
                        </td>
                      );
                    } else if (header.value === "sez" && type === "outward") {
                      return (
                        <td className="data_inside_table">{dataItem?.sez}</td>
                      );
                    } else if (
                      header.value === "sez_tax_payment" &&
                      type === "outward"
                    ) {
                      return (
                        <td className="data_inside_table">
                          {dataItem?.sez_tax_payment}
                        </td>
                      );
                    } else if (
                      header.value === "reverse_charge" &&
                      type === "outward"
                    ) {
                      return (
                        <td className="data_inside_table">
                          {dataItem?.is_gstr1_filed !== 1 ? (
                            <Select
                              styles={tableSelect}
                              components={{
                                IndicatorSeparator: () => null,
                              }}
                              placeholder="Select"
                              disabled={fetching}
                              name="reverse_charge"
                              value={
                                dataItem.reverse_charge
                                  ? {
                                      value: dataItem.reverse_charge,
                                      label: dataItem.reverse_charge,
                                    }
                                  : null
                              }
                              options={REVERSE_CHARGE_OUTWARD_OPTIONS}
                              onChange={(e) =>
                                handleInputChange(
                                  e,
                                  dataItem._id,
                                  "reverse_charge"
                                )
                              }
                            />
                          ) : (
                            dataItem.reverse_charge
                          )}
                        </td>
                      );
                    }
                  } else {
                    if (header.value === "seller_name") {
                      return (
                        <td className="data_inside_table">
                          <div>{dataItem?.seller_name}</div>
                          <div className="below-header">
                            {dataItem.seller_gstin}
                          </div>
                        </td>
                      );
                    } else if (header.value === "seller_type") {
                      return (
                        <td className="data_inside_table">
                          {dataItem?.seller_type}
                        </td>
                      );
                    } else if (
                      header.value === "purchase_from_composition_dealer"
                    ) {
                      return (
                        <td className="data_inside_table">
                          {dataItem?.purchase_from_composition_dealer}
                        </td>
                      );
                    } else if (header.value === "gstr2a") {
                      return (
                        <td
                          className="data_inside_table"
                          style={{ minWidth: "100px" }}
                        >
                          {
                            <Select
                              styles={tableSelect}
                              components={{
                                IndicatorSeparator: () => null,
                              }}
                              placeholder="Select"
                              disabled={fetching}
                              name="gstr2a"
                              value={
                                dataItem.gstr2a
                                  ? dataItem.gstr2a === "Yes"
                                    ? AGREE_DISAGREE_OPTIONS[0]
                                    : AGREE_DISAGREE_OPTIONS[1]
                                  : null
                              }
                              options={AGREE_DISAGREE_OPTIONS}
                              onChange={(e) =>
                                handleInputChange(e, dataItem._id, "gstr2a")
                              }
                            />
                          }
                        </td>
                      );
                    } else if (header.value === "gstr2b") {
                      return (
                        <td
                          className="data_inside_table"
                          style={{ minWidth: "100px" }}
                        >
                          {
                            <Select
                              styles={tableSelect}
                              components={{
                                IndicatorSeparator: () => null,
                              }}
                              placeholder="Select"
                              disabled={fetching}
                              name="gstr2b"
                              value={
                                dataItem.gstr2b
                                  ? dataItem.gstr2b === "Yes"
                                    ? AGREE_DISAGREE_OPTIONS[0]
                                    : AGREE_DISAGREE_OPTIONS[1]
                                  : null
                              }
                              options={AGREE_DISAGREE_OPTIONS}
                              onChange={(e) =>
                                handleInputChange(e, dataItem._id, "gstr2b")
                              }
                            />
                          }
                        </td>
                      );
                    } else if (header.value === "gstr3b") {
                      return (
                        <td className="data_inside_table">
                          {
                            <Select
                              styles={tableSelect}
                              components={{
                                IndicatorSeparator: () => null,
                              }}
                              placeholder="Select Date"
                              disabled={fetching}
                              name="gstr3b"
                              options={gstr1_options}
                              value={
                                dataItem.gstr3b
                                  ? {
                                      label: dataItem.gstr3b,
                                      value: dataItem.gstr3b,
                                    }
                                  : null
                              }
                              isSearchable
                              onChange={(e) =>
                                handleInputChange(e, dataItem._id, "gstr3b")
                              }
                            />
                          }
                        </td>
                      );
                    } else if (header.value === "gstr3b_month") {
                      return (
                        <td className="data_inside_table">
                          {
                            <Select
                              styles={tableSelect}
                              components={{
                                IndicatorSeparator: () => null,
                              }}
                              placeholder="Select Date"
                              disabled={fetching}
                              name="gstr3b_month"
                              options={gstr1_options}
                              value={
                                dataItem.gstr3b_month
                                  ? {
                                      label: dataItem.gstr3b_month,
                                      value: dataItem.gstr3b_month,
                                    }
                                  : null
                              }
                              isSearchable
                              onChange={(e) =>
                                handleInputChange(
                                  e,
                                  dataItem._id,
                                  "gstr3b_month"
                                )
                              }
                            />
                          }
                        </td>
                      );
                    } else if (header.value === "reclaim") {
                      return (
                        <td className="data_inside_table">
                          <div style={{ minWidth: "118px" }}>
                            {
                              <Select
                                styles={tableSelect}
                                components={{
                                  IndicatorSeparator: () => null,
                                }}
                                placeholder="Select Date"
                                isDisabled={
                                  //   fetching ||
                                  dataItem.whether_eligible !== "No - Other" ||
                                  !dataItem.gstr3b_month
                                }
                                name="reclaim"
                                options={getReclaimMonthsOptions(
                                  dataItem?.gstr3b_month?.split("-")[1],
                                  dataItem?.gstr3b_month?.split("-")[0],
                                  `${
                                    +dataItem?.gstr3b_month?.split("-")[1] + 1
                                  }`
                                )}
                                value={
                                  dataItem?.reclaim
                                    ? {
                                        label: dataItem?.reclaim,
                                        value: dataItem?.reclaim,
                                      }
                                    : null
                                }
                                isSearchable
                                onChange={(e) =>
                                  handleInputChange(e, dataItem._id, "reclaim")
                                }
                              />
                            }
                          </div>
                        </td>
                      );
                    } else if (header.value === "whether_eligible") {
                      return (
                        <td className="data_inside_table">
                          {
                            <Select
                              styles={tableSelect}
                              components={{
                                IndicatorSeparator: () => null,
                              }}
                              placeholder="Select"
                              disabled={fetching}
                              name="whether_eligible"
                              value={
                                dataItem?.whether_eligible
                                  ? {
                                      value: dataItem?.whether_eligible,
                                      label: dataItem?.whether_eligible,
                                    }
                                  : null
                              }
                              options={WHETHER_ELIGIBLE_OPTIONS}
                              onChange={(e) =>
                                handleInputChange(
                                  e,
                                  dataItem._id,
                                  "whether_eligible"
                                )
                              }
                            />
                          }
                        </td>
                      );
                    } else if (header.value === "classification") {
                      return (
                        <td className="data_inside_table">
                          {
                            <Select
                              styles={tableSelect}
                              components={{
                                IndicatorSeparator: () => null,
                              }}
                              placeholder="Select"
                              disabled={fetching}
                              name="classification"
                              value={
                                dataItem?.classification
                                  ? {
                                      value: dataItem.classification,
                                      label: dataItem.classification,
                                    }
                                  : {
                                      value: CLASSIFICATION_OPTIONS[0].value,
                                      label: CLASSIFICATION_OPTIONS[0].label,
                                    }
                              }
                              options={CLASSIFICATION_OPTIONS}
                              onChange={(e) =>
                                handleInputChange(
                                  e,
                                  dataItem._id,
                                  "classification"
                                )
                              }
                            />
                          }
                        </td>
                      );
                    } else if (header.value === "total_itc_amount") {
                      return (
                        <td className="data_inside_table">
                          {dataItem?.total_itc_amount?.toFixed(2)}
                        </td>
                      );
                    }
                  }
                  if (header.value === "") {
                    return (
                      <td
                        style={{ textAlign: "center" }}
                        className="data_inside_table"
                      >
                        {dataItem.isOpen ? (
                          <img
                            width="20px"
                            onClick={() => handleClick(dataItem._id)}
                            style={{ cursor: "pointer" }}
                            src={CollapseOpen}
                            className="accordion-arrow"
                          />
                        ) : (
                          <img
                            width="20px"
                            onClick={() => handleClick(dataItem._id)}
                            style={{ cursor: "pointer" }}
                            src={CollapseClose}
                            className="accordion-arrow"
                          />
                        )}
                        {dataItem?.is_gstr1_filed === 1 ? (
                          <img src={LockGreyIcon} alt="lock-icon" />
                        ) : (
                          ""
                        )}
                      </td>
                    );
                  } else if (header.value === "invoice_date") {
                    return (
                      <td className="data_inside_table">
                        {formatDate(dataItem.invoice_date)}
                      </td>
                    );
                  } else if (header.value === "invoice_number") {
                    return (
                      <td className="data_inside_table">
                        {isClickable ? (
                          <Link
                            target="_blank"
                            to={finalRedirectLink}
                            // onClick={() => handleSetLocalStorageData(data?.ledger_id)}
                            style={{
                              color: "#dd4433",
                              textDecoration: "underLine",
                              cursor: "pointer",
                            }}
                          >
                            {dataItem.invoice_number}
                          </Link>
                        ) : (
                          dataItem?.invoice_number
                        )}
                      </td>
                    );
                  } else if (header.value === "invoice_value") {
                    return (
                      <td className="data_inside_table">
                        {dataItem.invoice_value}
                      </td>
                    );
                  } else if (header.value === "pos") {
                    return (
                      <td className="data_inside_table">
                        {dataItem.place_of_supply}
                      </td>
                    );
                  } else if (header.value === "sales_type") {
                    return (
                      <td className="data_inside_table">
                        {dataItem.sales_type}
                      </td>
                    );
                  } else if (header.value === "gst_exemption") {
                    return (
                      <td className="data_inside_table">
                        {
                          <Select
                            styles={tableSelect}
                            components={{
                              IndicatorSeparator: () => null,
                            }}
                            placeholder="Select"
                            name="gst_exemption"
                            value={
                              dataItem.gst_exemption
                                ? dataItem?.gst_exemption === "nil_rated"
                                  ? { label: "Nil Rated", value: "nil_rated" }
                                  : dataItem?.gst_exemption ===
                                    "exempted_supply"
                                  ? {
                                      label: "Exempted Supply",
                                      value: "exempted_supply",
                                    }
                                  : dataItem?.gst_exemption === "non_gst"
                                  ? { label: "Non GST", value: "non_gst" }
                                  : null
                                : null
                            }
                            disabled={fetching}
                            options={GST_EXEMPTION}
                            onChange={(e) =>
                              handleInputChange(
                                e,
                                dataItem._id,
                                "gst_exemption"
                              )
                            }
                          />
                        }
                      </td>
                    );
                  } else if (header.value === "reverse_charge") {
                    return (
                      <td className="data_inside_table">
                        {
                          <Select
                            styles={tableSelect}
                            components={{
                              IndicatorSeparator: () => null,
                            }}
                            placeholder="Select"
                            disabled={fetching}
                            name="reverse_charge"
                            value={
                              dataItem.reverse_charge
                                ? {
                                    value: dataItem.reverse_charge,
                                    label: dataItem.reverse_charge,
                                  }
                                : null
                            }
                            options={REVERSE_CHARGE_INWARD_OPTIONS}
                            onChange={(e) =>
                              handleInputChange(
                                e,
                                dataItem._id,
                                "reverse_charge"
                              )
                            }
                          />
                        }
                      </td>
                    );
                  } else if (header.value === "total_cgst_amount") {
                    return (
                      <td className="data_inside_table">
                        {dataItem?.total_cgst_amount?.toFixed(2)}
                      </td>
                    );
                  } else if (header.value === "total_igst_amount") {
                    return (
                      <td className="data_inside_table">
                        {dataItem?.total_igst_amount?.toFixed(2)}
                      </td>
                    );
                  } else if (header.value === "total_sgst_amount") {
                    return (
                      <td className="data_inside_table">
                        {dataItem?.total_sgst_amount?.toFixed(2)}
                      </td>
                    );
                  } else if (header.value === "total_taxable_value") {
                    return (
                      <td className="data_inside_table">
                        {dataItem?.total_taxable_value?.toFixed(2)}
                      </td>
                    );
                  } else if (header.value === "document_type") {
                    return (
                      <td className="data_inside_table">
                        {convertDocumentType(dataItem.document_type)}
                      </td>
                    );
                  } else if (header.value === "gstr3b_type_arr") {
                    return (
                      <td
                        className="data_inside_table"
                        style={{
                          whiteSpace: gstr3BType ? "normal" : "nowrap",
                          wordBreak: "break-word",
                          minWidth: "300px",
                        }}
                      >
                        {gstr3BType
                          ? gstr3BType?.slice(0, gstr3BType.length - 2)
                          : "NA"}
                      </td>
                    );
                  } else if (header.value === "table_no_of_gstr3b") {
                    return (
                      <td className="data_inside_table">
                        {dataItem?.is_gstr1_filed !== 1 ? (
                          <Select
                            styles={tableSelect}
                            components={{
                              IndicatorSeparator: () => null,
                            }}
                            placeholder="Select Date"
                            disabled={fetching}
                            name="table_no_of_gstr3b"
                            options={gstr1_options}
                            value={
                              dataItem.table_no_of_gstr3b
                                ? {
                                    label: dataItem.table_no_of_gstr3b,
                                    value: dataItem.table_no_of_gstr3b,
                                  }
                                : null
                            }
                            isSearchable
                            onChange={(e) =>
                              handleInputChange(
                                e,
                                dataItem._id,
                                "table_no_of_gstr3b"
                              )
                            }
                          />
                        ) : (
                          dataItem.table_no_of_gstr3b
                        )}
                      </td>
                    );
                  } else if (header.value === "total_invoice_value") {
                    return (
                      <td className="data_inside_table">
                        {dataItem?.total_invoice_value?.toFixed(2)}
                      </td>
                    );
                  }
                })}
            </tr>

            {dataItem.isOpen && (
              <tr style={{ borderBottom: "hidden", backgroundColor: "white" }}>
                <td
                  style={{ padding: "10px 0 0 0", backgroundColor: "white" }}
                ></td>
                <td
                  colSpan={tableHeader.length}
                  style={{
                    padding: "10px 0 0 0",
                    backgroundColor: "white",
                    textAlign: "left",
                  }}
                >
                  <h6>Item Details</h6>
                </td>
              </tr>
            )}

            {dataItem.isOpen && (
              <tr>
                <td style={{ padding: "0", backgroundColor: "white" }}></td>

                <td
                  colSpan={tableHeader.length}
                  style={{ padding: "0", backgroundColor: "white" }}
                >
                  <ItemDataTable
                    itemHeader={
                      type === "outward"
                        ? dataItem?.document_type === "rcm_invoice"
                          ? itemHeader?.filter(
                              (data: any) => data.value != "nature_of_income"
                            )
                          : itemHeader?.filter(
                              (data: any) => data.value != "nature_of_expense"
                            )
                        : itemHeader
                    }
                    itemData={dataItem?.items_data}
                    type={type}
                  />
                </td>
              </tr>
            )}
          </>
        );
      });

    return finalTableData;
  };

  const handleClick = (id: string) => {
    newData?.map((elem: any) => {
      if (elem._id === id) {
        elem.isOpen = !elem.isOpen;
      }
    });
    setData([...newData]);
  };

  return <>{renderMainTableRow()}</>;
};

export default MainTableBody;
